import { useEffect, useState } from 'react';

import { IUseState } from '../../../types/IUseState';
import { getPage, IPage, IPageFetcher } from '../../page';

import { usePageFetcher } from './usePageFetcher';

export interface IUsePage {
    loading: boolean;
    error?: string;
    page: IPage | null;
}

export function usePage (id: string): IUsePage {
    const client: IPageFetcher | null = usePageFetcher();
    const [loading, setLoading]: IUseState<boolean> = useState<boolean>(true);
    const [error, setError]: IUseState<string | undefined> = useState<string | undefined>();
    const [page, setPage]: IUseState<IPage | null> = useState<IPage | null>(null);

    useEffect((): void => {
        if (!client) {
            return;
        }

        setLoading(true);
        getPage(id, client).then((page: IPage): void => {
            setPage(page);
        }).catch((error: any): void => {
            setError(error.message);
        }).finally((): void => {
            setLoading(false);
        });
    }, [id, client]);

    return {
        loading,
        error,
        page,
    };
}
